module.exports = __webpack_public_path__ + "static/media/male.fdb8bf2d.svg";